function AppReducer(state, action) {
  switch (action.type) {
    case "SET_IMAGE":
      return {
        ...state,
        image: action.payload,
      }

    case "SET_COLORS":
      return {
        ...state,
        colors: action.payload,
      }

    default:
      return state
  }
}

export default AppReducer
